import { useEffect, useState } from "react";
import styled from "styled-components";
import MessageModal from "../MessageModal";
import Button from "../Button";
import { userContext } from '../../usercontext';
import Input from "../InputComp";
import { fetchWrapper } from "../../utils/apiHandlers";
import { formatPhoneInput } from "../../utils/helperfunctions";
import { AiOutlineEye, AiFillEyeInvisible } from "react-icons/ai";
import HorizontalLine from "../horizontalLine/";

interface Props{
  history?: any;
}

const Profile: React.FC<Props> = (props) => {

  const [user, setUser] = useState<any>(null)
  const [ firstname, setfirstname ] = useState("")
  const [ lastname, setlastname ] = useState("")
  const [ phonenumber, setphonenumber ] = useState("")
  const [ websiteurl, setwebsiteurl ] = useState("")
  const [ address, setaddress ] = useState("")
  const [ newpassword, setnewpassword ] = useState("")
  const [ oldpassword, setoldpassword ] = useState("")

  const [ showpwd, setshowpwd ] = useState(false)

  const [modalheader, setmodalheader] = useState('')
  const [modalmessage, setmodalmessage] = useState('')
  const [modalprogress, setmodalprogress] = useState(false)
  const [modalstate, setmodalstate] = useState(false)

  const toggleshowpwd = () =>{
    setshowpwd(!showpwd)
  }

  const changepassword = async () => {
    if(newpassword.length<8){
      openModal("Warning", "The password must be at least 8 characters long.", false)
      return
    }
    let r = await fetchWrapper.post("/api/authenticate/changepassword", {userid:user.userid, oldpassword:oldpassword,newpassword:newpassword}).then((r)=> r).catch((error: any)=>{
      openModal("Warning", "Failed to change password", false)
      return
    })

      if(r.status==200){
        openModal("Message", "Password chanaged", false)
        setoldpassword("")
        setnewpassword("")
        return
      }else if(r.status==210){
        openModal("Warning", "Incorrect password", false)
        setoldpassword("")
        setnewpassword("")
        return
      }
      else{
        openModal("Warning", "Failed to change password", false)
        setoldpassword("")
        setnewpassword("")
        return
      }
  }

  const openModal = (header: string, message: string, progress?: boolean) => {
    setmodalheader(header)
    setmodalmessage(message)
    setmodalstate(true)
    setmodalprogress(progress?progress: false)

  }

  const update = async () => {
    openModal("Message", "updating", true)
    try{
        let response = await userContext.updateprofile(user.userid, firstname, lastname, phonenumber, websiteurl, address )
        if(response){
            openModal("Message", "Profile updated.", false)
        }else{
            openModal("Error", "Failed.", false)
        }

    }catch(error){
        openModal("Error", "Failed.", false)
    }
  }

  const changephonenumber = (e: any) =>{
    if(e.target.value.length>12)return
    const re = /^[0-9\b]+$/;
    let newTxt = e.target.value.replace(/-/g, "");
    let phone = "";
    if (newTxt === "" || re.test(newTxt)) {
      phone = formatPhoneInput(newTxt, [4, 8]);
      setphonenumber(phone);
    }
  }

  useEffect(() => {
    const subscription = userContext.user.subscribe((x:any) => setUser(x))
    return () => subscription.unsubscribe()
  }, [])

  useEffect(()=>{
    if(!user)return;
    if(user.status!==200){
      props.history.push("/login")
    }
    setfirstname(user.firstname)
    setlastname(user.lastname)
    setphonenumber(user.phonenumber)
    setwebsiteurl(user.websiteurl)
    setaddress(user.address)
    setwebsiteurl(user.websiteurl)
  },[user])

  return (
    <>
      <MainContainer>
          <MessageModal header={modalheader} message={modalmessage} state={modalstate} handleClose={()=> setmodalstate(false)} progress={modalprogress} />
          <Header>Profile</Header>
          {user&&user.status==200?<>
            <Input id="useremail" placeholder="email" value={user.email} onChange={(e: any) => {}} />
            <Input id="firstnameid" placeholder="first name" value={firstname} onChange={(e: any) => {setfirstname(e.target.value)}} />
            <Input id="lastnameid" placeholder="last name" value={lastname} onChange={(e: any) => {setlastname(e.target.value)}} />
            <Input id="phonenumberid" placeholder="phone number" value={phonenumber} onChange={changephonenumber} />
            <Input id="addressid" placeholder="address" value={address} onChange={(e)=>setaddress(e.target.value)} />
            <Input id="websiteid" placeholder="website url" value={websiteurl} onChange={(e: any)=>setwebsiteurl(e.target.value)} />
            <Button handleClick={()=>update()} text="Update" />
            <HorizontalLine />
            <SubHeader>Change Password</SubHeader>

            <Column style={{alignItems:'flex-start'}}>
                <Input id="oldchangepwdinput" placeholder="current password" onChange={(e)=>setoldpassword(e.target.value)} value={oldpassword} type={"password"} width="350" />

                <NewPwdContainer>
                  <Input id="changepwdinput" placeholder="new password" onChange={(e)=>setnewpassword(e.target.value)} value={newpassword} type={showpwd?"text":"password"} width="350" />
                  <div>
                    {showpwd?<AiOutlineEye onClick={toggleshowpwd}/> : <AiFillEyeInvisible onClick={toggleshowpwd}/>}
                  </div>
                </NewPwdContainer>
            </Column>
            <Button handleClick={changepassword} text="Change password" />

            <HorizontalLine />
            <Hint>Looking for your secret key or the embed code? That moved to <b>Get Started</b>.</Hint>
            </>:<></>}
      </MainContainer>
    </>
  );
};

const NewPwdContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Hint = styled.div`
  font-size: 12px;
  color: #5B6472;
  padding: 10px;
`;

const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
`

const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
  @media (max-width: 770px) {
    margin: 0;
    padding: 0px 0px;
    justify-content: flex-start;
    align-items: flex-start;
  }
`

const Header = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 40px;
    justify-content: flex-end;
    color: black;
`;

const SubHeader = styled.div`
    padding: 10px;
    font-weight: 700;
    font-size: 30px;
    justify-content: flex-end;
    color: black;
`;

export default Profile;
